import { Grid } from '@mui/material';
import { welcomeRoutes } from 'common/utils/routes';

export const WelcomePage = () => {
  return (
    <Grid
      sx={{
        minHeight: '100vh',
      }}
      container
    >
      {welcomeRoutes}
    </Grid>
  );
};
